module.exports = __webpack_public_path__ + "static/media/un.d55b6b46.svg";